/* eslint-disable max-lines */
import { stringify } from 'qs'
import { message as $message } from 'antd'
import {
    CHANNEL_ORDER_ROUTE,
    SUPPLIER_ORDER_MANAGE,
    SUPPLIER_ORDER_ROUTE,
    CHANNEL_AFTER_SALES_MANAGE,
    SUPPLIER_AFTER_SALES_MANAGE,
    SUPPLIER_DISTRIBUTOR_AFTER_SALES,
    SUPPLIER_AFTER_SALES_SETTINGS,
    CHANNEL_AFTER_SALES_SETTINGS,
    SUPPLIER_AFTER_SALES_AUTOMATION,
    CHANNEL_ORDER_SETTINGS,
    SUPPLIER_ORDER_SETTINGS,
    CHANNEL_AFTER_SALES_AUTOMATION,
    CHANNEL_EXPRESS_INTERCEPTION,
    SUPPLIER_EXPRESS_INTERCEPTION,
    CHANNEL_HISTORY_ORDER,
    SUPPLIER_HISTORY_ORDER,
    SUPPLIER_AFTER_SALES_SETTINGS_DIS_SET,
} from '@/modules/order/constants'
import { getPlatfromMap } from '@/modules/order/utils/checkAfterSales'
import { ALL } from '@/components/OrderWidgets/DistributeOrderStatus/index'
import { CONFIRMED_KEY } from '@/components/SupplierWidgets/CooperStatus'
import { history as historyPush } from 'umi'
import { jump, getLocalTerminalDomain } from '@/utils/jump'
import { messageChannel } from '@/utils/messageChannel'
import { getStore } from '@/utils/dva'
import { queryErpOrders } from '@/services/distributeOrder'
import { addQueryToUrl } from '@/utils/url'
import { env, envJump } from '@/modules/globals'
import { isInnerApiUserLoginStateV2WhiteListEnabled } from '@/modules/globals/features/whiteList'
import { getTerminaDomain } from '@/utils/utils'
import { getDlzIsFromSupply } from '@/modules/dlz/helper'

const jumpEnd = (terminalName: string, path: string) => {
    const origin = getTerminaDomain(terminalName)

    const fullUrl = `${origin}${path}`

    window.open(fullUrl)
}
const handlePath = (path, query, needLong) => {
    let newPath = path
    // 不是作为子应用使用 path,用短路径
    if (window.PROJECT_CONFIG.terminalName === 'TOWER' && !needLong) {
        const keys = newPath.split('/')
        newPath = `/${keys[keys.length - 1]}`
    }
    const queryStr = stringify(query, { addQueryPrefix: true })
    return `${newPath}${queryStr}`
}

// 先跑一段时间看有没有问题
const handlePathV2 = async (path, query) => {
    const isGyl = await env.isGyl()
    let newPath = path
    // 供应链内塔内跳用的是短路径
    const isLongPath = isGyl && window.PROJECT_CONFIG.terminalName !== 'TOWER'
    if (!isLongPath) {
        const keys = newPath.split('/')
        newPath = `/${keys[keys.length - 1]}`
    }
    if (!isGyl) {
        newPath = `${getTerminaDomain(window.PROJECT_CONFIG.towerTerminalName)}${newPath}`
    }
    // 拼接参数
    const keys = Object.keys(query)
    if (Array.isArray(keys) && keys.length) {
        newPath = keys.reduce(
            (res, item, index) => {
                return `${res}${item}=${index === keys.length - 1 ? query[item] : `${query[item]}&`}`
            },
            [`${newPath}?`],
        )
    }
    return newPath
}

// isChannelType 是否是在供应侧以分销商的身份去看
export const handelClickToExportLogDetail = ({ id, isChannelType, pageType }) => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = `/tradeManage/statementList/detail?id=${id}`
        if (isChannelType) {
            path += '&isChannelType=1'
        }
        if (pageType) {
            path += `&pageType=${pageType}`
        }
    }
    if (MASTER_IS_CHANNEL) {
        path = `/channel/my/bill/statement/detail?id=${id}`
    }
    commonHistoryPush(path)
}

// 跳转到订单未结算页面
export const handelClickToOrderNotSettled = (query = {}) => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/tradeManage/statementList'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/bill/unStatementOrder'
    }
    const queryString = Object.keys(query)
        .map(key => `${key}=${query[key]}`)
        .join('&')
    if (queryString) {
        path = `${path}?${queryString}`
    }
    commonHistoryPush(path)
}

// 跳转到已结算订单页面
export const handelClickToOrderSettled = (query = {}) => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/tradeManage/statementList/statementOrder'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/bill/statementOrder'
    }
    const queryString = Object.keys(query)
        .map(key => `${key}=${query[key]}`)
        .join('&')
    if (queryString) {
        path = `${path}?${queryString}`
    }
    commonHistoryPush(path)
}

// 跳转到订单结算日志
export const handelClickToExportLog = (terminalName, id) => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/tradeManage/statementList/orderExportLog'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/bill/orderExportLog'
    }
    if (id) {
        path += `?logId=${id}`
    }

    commonHistoryPush(path)
}

// 跳转到我的供应商
export const handelClickToSupplier = outFlag => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/suppliersManage/suppliersList/onlineSuppliers'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/supplier'
    }
    if (outFlag) {
        path += `?outFlag=true&status=${CONFIRMED_KEY}`
    }

    commonHistoryPush(path)
}

// 跳转到订单结算单页面
export const handelClickToGenerateStatement = ({ query = '' } = {}) => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/tradeManage/statementList/statement'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/bill/statement'
    }
    if (query) {
        path += query
    }

    commonHistoryPush(path)
}

// 跳到订单结算页面
export const onClickToGenerateStatement = (query = {}) => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/tradeManage/statementList'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/bill/statement'
    }
    if (query) {
        path = addQueryToUrl(path, query)
    }

    commonHistoryPush(path)
}

// 去设置快递 到绑定快递页
export const onGoBindExpress = () => {
    let path = ''
    if (MASTER_IS_SUPPLIER) {
        path = '/tradeManage/bindExpress'
    }
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/bindExpress'
    }
    jump({
        erpTabName: '绑定快递',
        gylOpenLink: path,
    })
    // windowOpen('绑定快递', path)
    // window.open(path, '_blank')
}

// 去分销商品 只有渠道测有分销商品
export const onGoDistributeGoods = styleCodes => {
    let path = ''
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/myGoods/alreadyReleaseGoods/index'
    } else {
        path = '/manage/goods/distributionGoodsManage'
    }

    if (styleCodes) {
        path += `?styleCodes=${styleCodes}`
    }
    commonHistoryPush(path)
}

// 去分销订单(代发订单)
export const onGoDistributeOrder = ({ type = '', query = '' } = {}) => {
    let path = ''
    if (MASTER_IS_CHANNEL) {
        path = CHANNEL_ORDER_ROUTE
    }
    if (MASTER_IS_SUPPLIER) {
        path = SUPPLIER_ORDER_ROUTE
    }
    if (query) {
        path += query
    }
    if (type === 'push') {
        historyPush.push(path)
        return
    }

    commonHistoryPush(path)
}
// 去全部订单
export const onGoAllOrder = ({ type = '', query = '' } = {}) => {
    // erp/epaas内嵌
    const { hostInfo } = window?.hostInstance?.getEnvInfo() || {}
    const isEmbeddedApp = hostInfo?.isInErp || hostInfo?.isInEpaas
    let path = ''
    let terminalName = ''
    if (window.MASTER_IS_CHANNEL) {
        path = CHANNEL_ORDER_ROUTE
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    } else {
        path = SUPPLIER_ORDER_MANAGE
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }

    if (query) {
        path += query
    }
    if (isEmbeddedApp) {
        envJump.open({
            name: '全部订单',
            url: `${getLocalTerminalDomain(PROJECT_CONFIG.supplierTerminalName)}${path}&m=n`, // 供应链这边只需要 url
            isRefresh: true,
        })
        return
    }
    if (type === 'open') {
        jumpEnd(terminalName, path)
        return
    }
    if (!window.__POWERED_BY_GYL_FRAME__) {
        const pathArr = path.split('/')
        path = `/${pathArr[pathArr.length - 1]}`
    }
    commonHistoryPush(path)
}

// 去在线收付款页面
export const onGoOnlinePayment = ({ type = '', query = '' } = {}) => {
    // erp/epaas内嵌
    const { hostInfo } = window?.hostInstance?.getEnvInfo() || {}
    const isEmbeddedApp = hostInfo?.isInErp || hostInfo?.isInEpaas
    let path = ''
    let terminalName = ''
    if (window.MASTER_IS_CHANNEL) {
        path = '/channel/my/onlinePayment'
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    } else {
        path = '/tradeManage/onlinePayment'
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }

    if (query) {
        path += query
    }
    if (isEmbeddedApp) {
        envJump.open({
            name: '在线收付款',
            url: `${getLocalTerminalDomain(PROJECT_CONFIG.supplierTerminalName)}${path}&m=n`, // 供应链这边只需要 url
            isRefresh: true,
        })
        return
    }
    if (type === 'open') {
        jumpEnd(terminalName, path)
        return
    }
    if (!window.__POWERED_BY_GYL_FRAME__) {
        const pathArr = path.split('/')
        path = `/${pathArr[pathArr.length - 1]}`
    }
    commonHistoryPush(path)
}

// 去店铺列表
export const onGoStoreManage = () => {
    let path = ''
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/storeManage?create=1'
    }
    if (MASTER_IS_SUPPLIER) {
        path = '/storeManage/list?create=1'
    }
    commonHistoryPush(path)
}

// 合作商品中心
export const onGoCooperation = () => {
    let path = ''
    if (MASTER_IS_CHANNEL) {
        path = '/channel/my/myGoods/cooperationGoodsCenter'
    }
    if (MASTER_IS_SUPPLIER) {
        path = '/dashboard'
    }
    commonHistoryPush(path)
}

export const commonHistoryPush = (path: string) => {
    if (window.__POWERED_BY_GYL_FRAME__) {
        messageChannel.postMessage('history/push', { path })
        return
    }

    historyPush.push(path)
}

// 去售后管理
export const onGoAfterSales = params => {
    // isErpJumpNoOpen = true  (不新开窗口，嵌套在erp内，用history.push,
    // needShortPath = true 需要短路径
    let terminalName = ''
    const { query = {}, isErpJumpNoOpen = false, needShortPath = false } = params || {}
    // erp/epaas内嵌
    const { hostInfo } = window?.hostInstance?.getEnvInfo() || {}
    const isEmbeddedApp = hostInfo?.isInErp || hostInfo?.isInEpaas

    let path = ''
    if (MASTER_IS_CHANNEL) {
        path = CHANNEL_AFTER_SALES_MANAGE
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    }
    if (MASTER_IS_SUPPLIER) {
        path = SUPPLIER_AFTER_SALES_MANAGE
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }
    const keys = Object.keys(query)
    if (Array.isArray(keys) && keys.length) {
        path = keys.reduce(
            (res, item, index) => {
                return `${res}${item}=${index === keys.length - 1 ? query[item] : `${query[item]}&`}`
            },
            [`${path}?`],
        )
    }
    if (isErpJumpNoOpen) {
        if (!window.__POWERED_BY_GYL_FRAME__ || needShortPath) {
            const pathArr = path.split('/')
            path = `/${pathArr[pathArr.length - 1]}`
        }
        if (needShortPath) {
            historyPush.push(path)
            return
        }
        commonHistoryPush(path)
    } else {
        const fullUrl = `${getTerminaDomain(terminalName)}${path}`
        if (isEmbeddedApp) {
            window.jst_core.tab.open({
                name: '售后管理',
                url: `${fullUrl}&m=n`,
                isRefresh: true,
            })
            return
        }
        // 替换跳转方法
        jump({
            erpTabLink: '',
            erpTabName: '售后管理',
            erpTabRefresh: true,
            gylOpenLink: fullUrl,
        })
    }
}
// 去分销商的售后单（只有供应侧有）
export const onGoDistributorAfterSale = ({ query = {}, newBrowserTab } = {}) => {
    let terminalName = window.PROJECT_CONFIG.supplierTerminalName
    let path = SUPPLIER_DISTRIBUTOR_AFTER_SALES
    const resultPath = handlePath(path, query, newBrowserTab)
    const fullUrl = `${getTerminaDomain(terminalName)}${resultPath}`
    // 如果是新开浏览器tab
    if (newBrowserTab) {
        window.open(fullUrl)
        return
    }
    historyPush.push(resultPath)
}

// 去售后自动化
export const goAfterSaleAuto = ({ query = {}, newBrowserTab } = {}) => {
    let path = ''
    let terminalName = ''
    if (MASTER_IS_CHANNEL) {
        path = CHANNEL_AFTER_SALES_AUTOMATION
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    }
    if (MASTER_IS_SUPPLIER) {
        path = SUPPLIER_AFTER_SALES_AUTOMATION
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }
    const resultPath = handlePath(path, query, newBrowserTab)
    const fullUrl = `${getTerminaDomain(terminalName)}${resultPath}`
    // 如果是新开浏览器tab
    if (newBrowserTab) {
        window.open(fullUrl)
        return
    }
    historyPush.push(resultPath)
}
// 去售后设置-供销设置（我是供应商）
export const goAfterSaleSettings = ({ query = {}, newBrowserTab, forceSupplierTerminal } = {}) => {
    let path = ''
    let terminalName = ''

    if (forceSupplierTerminal && !window.MASTER_IS_SUPPLIER) {
        path = SUPPLIER_AFTER_SALES_SETTINGS
        terminalName = window.PROJECT_CONFIG.supplierTerminalName

        const resultPath = handlePath(path, query, newBrowserTab)
        const fullUrl = `${getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)}${resultPath}`

        window.open(fullUrl)
    } else {
        if (MASTER_IS_CHANNEL) {
            path = CHANNEL_AFTER_SALES_SETTINGS
            terminalName = window.PROJECT_CONFIG.channelTerminalName
        }
        if (MASTER_IS_SUPPLIER) {
            path = SUPPLIER_AFTER_SALES_SETTINGS
            terminalName = window.PROJECT_CONFIG.supplierTerminalName
        }
        const resultPath = handlePath(path, query, newBrowserTab)
        const fullUrl = `${getTerminaDomain(terminalName)}${resultPath}`
        // 如果是新开浏览器tab
        if (newBrowserTab) {
            window.open(fullUrl)
            return
        }
        historyPush.push(resultPath)
    }
}
// 去售后设置-分销设置（我是分销商）
export const goAfterSaleSettingsDisSet = ({ query = {}, newBrowserTab } = {}) => {
    let path = ''
    let terminalName = ''
    if (MASTER_IS_CHANNEL) {
        path = CHANNEL_AFTER_SALES_SETTINGS
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    }
    if (MASTER_IS_SUPPLIER || getDlzIsFromSupply()) {
        path = SUPPLIER_AFTER_SALES_SETTINGS_DIS_SET
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }
    const resultPath = handlePath(path, query, newBrowserTab)
    const fullUrl = `${getTerminaDomain(terminalName)}${resultPath}`
    // 如果是新开浏览器tab
    if (newBrowserTab) {
        window.open(fullUrl)
        return
    }
    historyPush.push(resultPath)
}
// 去设置
export const goOrderSettings = ({ query = {}, newBrowserTab } = {}) => {
    let path = ''
    let terminalName = ''
    if (MASTER_IS_CHANNEL) {
        path = CHANNEL_ORDER_SETTINGS
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    }
    if (MASTER_IS_SUPPLIER) {
        path = SUPPLIER_ORDER_SETTINGS
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }
    const resultPath = handlePath(path, query, newBrowserTab)
    const fullUrl = `${getTerminaDomain(terminalName)}${resultPath}`
    // 如果是新开浏览器tab
    if (newBrowserTab) {
        window.open(fullUrl)
        return
    }
    historyPush.push(resultPath)
}
// 去快递拦截页面
export const goExpressInterception = ({ query = {} } = {}) => {
    // 这里isGyl()拿不到实时的值，暂时加个延时
    setTimeout(async () => {
        const isGyl = await env.isGyl()
        let path = ''
        if (MASTER_IS_CHANNEL) {
            path = CHANNEL_EXPRESS_INTERCEPTION
        }
        if (MASTER_IS_SUPPLIER) {
            path = SUPPLIER_EXPRESS_INTERCEPTION
        }
        const resultPath = await handlePathV2(path, query)
        if (isGyl && window.PROJECT_CONFIG.terminalName === 'TOWER') {
            historyPush.push(resultPath)
        } else {
            envJump.open({
                name: '快递拦截',
                url: resultPath, // 供应链这边只需要 url
                isRefresh: true,
            })
        }
    }, 1000)
}
// 去售后导出日志
export const goAfterSaleExportLog = () => {
    const path = `/afterSaleExportLog`

    historyPush.push(path)
}
// 判断待退款 已退款标签是否可以跳转售后管理
export const IsCanGoAfterSales = ({ shopSite }) => {
    const platforms = getPlatfromMap()
    return !!platforms[shopSite]
}

// 是否包含【分销预付费】标签并且是分销+ 的订单
export const getFenXiaoPrePayOidList = list => {
    if (Array.isArray(list)) {
        const flag = list.some(v => v.labels?.includes('分销预付费') && isFenPlusOrder(v.orderType))
        return flag
    }
    return false
}
/** 是否是分销预付费订单 */
export const getFenXiaoPrePayOrder = orderLabels => {
    return orderLabels?.includes('分销预付费')
}
// 判断是否是供销Plus订单
export const isGXPlusOrder = orderType => {
    return orderType?.includes('供销Plus')
}
// 判断是否是分销Plus订单
export const isFenPlusOrder = orderType => {
    return orderType?.includes('分销Plus')
}
// 判断是否是供销Plus并且是分销Plus订单
export const isFenAndGxPlusOrder = orderType => {
    return orderType?.includes('分销Plus') && orderType?.includes('供销Plus')
}
// 判断是否是自营订单
export const isSelfOrder = orderType => {
    return !(isGXPlusOrder(orderType) || isFenPlusOrder(orderType))
}
// 判断仅包含分销+ 不包含供销+
export const isFxPlusNoGxPlusFun = orderType => {
    return orderType?.includes('分销Plus') && !orderType?.includes('供销Plus')
}

// 判断仅包含供销+ 不包含分销+
export const isGxPlusNoFxPlusFun = orderType => {
    return !orderType?.includes('分销Plus') && orderType?.includes('供销Plus')
}
// 通信售后预警，跳到售后管理页
export const dataAfterWarnGoAfterSale = ({ success = [] } = {}) => {
    const pathname = MASTER_IS_CHANNEL ? CHANNEL_AFTER_SALES_MANAGE : SUPPLIER_AFTER_SALES_MANAGE

    let queryStr = success?.length ? `?afterSaleOrderNoList=${success?.join(',')}` : ''
    let path = `${pathname}${queryStr}`
    window.parent.postMessage(
        {
            action: 'jump',
            payload: {
                erpTabLink: `${getLocalTerminalDomain(
                    window.PROJECT_CONFIG.supplierTerminalName,
                )}${SUPPLIER_AFTER_SALES_MANAGE}${queryStr}`,
                erpTabName: '售后（极速版）',
                gylUrl: path,
            },
        },
        '*',
    )
}
// 通信售后预警，跳到售后自动化页
export const dataAfterWarnGoAfterAuto = () => {
    const pathname = MASTER_IS_CHANNEL ? CHANNEL_AFTER_SALES_AUTOMATION : SUPPLIER_AFTER_SALES_AUTOMATION

    let path = `${pathname}`
    window.parent.postMessage(
        {
            action: 'jump',
            payload: {
                erpTabLink: `${getLocalTerminalDomain(
                    window.PROJECT_CONFIG.supplierTerminalName,
                )}${SUPPLIER_AFTER_SALES_AUTOMATION}`,
                erpTabName: '售后（极速版）',
                gylUrl: path,
            },
        },
        '*',
    )
}

// 订单配置页
export const onGoPushBillDispose = () => {
    let path = ''
    if (window.MASTER_IS_CHANNEL) {
        path = '/channel/my/pushBillDispose'
    }
    if (window.MASTER_IS_SUPPLIER) {
        path = '/tradeManage/suppliersManage/pushBillDispose'
    }
    commonHistoryPush(path)
}

// 根据oid获取对应的数据list
export const getOrderListByOid = async ({ oidList }) => {
    const $store = getStore()
    const { coId, uid } = $store?.getState()?.user?.currentUser || {}
    const isWhiteListEnabled = isInnerApiUserLoginStateV2WhiteListEnabled()
    const values = {
        ...(isWhiteListEnabled ? {} : { coId, uid }),
        oidList,
        orderTypeEnum: ALL,
        searchType: 1,
        pageNum: 1,
        pageSize: 500,
    }

    const { success, data, message } = await queryErpOrders(values)
    if (success) {
        return data || []
    } else {
        $message.error(message)
    }
}

// 外跳历史订单页
export const jumpHistoryOrder = () => {
    let terminalName
    if (window.MASTER_IS_CHANNEL) {
        terminalName = window.PROJECT_CONFIG.channelTerminalName

        jumpEnd(terminalName, CHANNEL_HISTORY_ORDER)
    } else {
        terminalName = window.PROJECT_CONFIG.supplierTerminalName

        jumpEnd(terminalName, SUPPLIER_HISTORY_ORDER)
    }
}
